import React, { createContext, useState, useEffect } from "react";

export const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState("INR");
  // const [exchangeRates, setExchangeRates] = useState([]);
  const [exchangeRates, setExchangeRates] = useState({ "INR": 1, "EUR": 0.01097, "USD": 0.01196, "GBP": 0.009219, "AED": 0.04394, "AUD": 0.01777, "CAD": 0.01637, "CNY": 0.08696, "JPY": 1.8969, "KRW": 16.5431, "SAR": 0.04487, "RUB": 1.0570, "AFN": 0.8484, "ALL": 1.1019, "AMD": 4.6407 });

  // useEffect(() => {
  //   const fetchExchangeRates = async () => {
  //     try {
  //       const response = await fetch('https://v6.exchangerate-api.com/v6/ef9ca800f79b4a55cb8b9a2a/latest/INR');
  //       const data = await response.json();
  //       setExchangeRates(data.conversion_rates);
  //     } catch (error) {
  //       console.error("Error fetching exchange rates:", error);
  //     }
  //   };

  //   fetchExchangeRates();
  // }, []);

  // const getExchangeRates =
  // {
  //   "INR": 1,
  //   "EUR": 0.01097,
  //   "USD": 0.01196,
  //   "GBP": 0.009219,
  //   "AED": 0.04394,
  //   "AUD": 0.01777,
  //   "CAD": 0.01637,
  //   "CNY": 0.08696,
  //   "JPY": 1.8969,
  //   "KRW": 16.5431,
  //   "SAR": 0.04487,
  //   "RUB": 1.0570,

  //   "AFN": 0.8484,
  //   "ALL": 1.1019,
  //   "AMD": 4.6407,
  //   "ANG": 0.02142,
  //   "AOA": 10.5525,
  //   "ARS": 11.0499,
  //   "AWG": 0.02142,
  //   "AZN": 0.02034,
  //   "BAM": 0.02148,
  //   "BBD": 0.02393,
  //   "BDT": 1.4067,
  //   "BGN": 0.02148,
  //   "BHD": 0.004499,
  //   "BIF": 34.5094,
  //   "BMD": 0.01197,
  //   "BND": 0.01609,
  //   "BOB": 0.08278,
  //   "BRL": 0.06502,
  //   "BSD": 0.01197,
  //   "BTN": 1.0000,
  //   "BWP": 0.1617,
  //   "BYN": 0.03877,
  //   "BZD": 0.02393,
  //   "CDF": 33.8704,
  //   "CHF": 0.01071,
  //   "CLP": 10.8814,
  //   "COP": 47.3788,
  //   "CRC": 6.2525,
  //   "CUP": 0.2872,
  //   "CVE": 1.2111,
  //   "CZK": 0.2783,
  //   "DJF": 2.1265,
  //   "DKK": 0.08192,
  //   "DOP": 0.7079,
  //   "DZD": 1.6082,
  //   "EGP": 0.5747,
  //   "ERN": 0.1795,
  //   "ETB": 0.6914,
  //   "FJD": 0.02667,
  //   "FKP": 0.009230,
  //   "FOK": 0.08192,
  //   "GEL": 0.03226,
  //   "GGP": 0.009230,
  //   "GHS": 0.1853,
  //   "GIP": 0.009230,
  //   "GMD": 0.7759,
  //   "GNF": 103.6963,
  //   "GTQ": 0.09279,
  //   "GYD": 2.5038,
  //   "HKD": 0.09342,
  //   "HNL": 0.2962,
  //   "HRK": 0.08275,
  //   "HTG": 1.5794,
  //   "HUF": 4.3051,
  //   "IDR": 193.3627,
  //   "ILS": 0.04335,
  //   "IMP": 0.009230,
  //   "IQD": 15.6996,
  //   "IRR": 508.6900,
  //   "ISK": 1.6394,
  //   "JEP": 0.009230,
  //   "JMD": 1.8715,
  //   "JOD": 0.008483,
  //   "KES": 1.5562,
  //   "KGS": 1.0235,
  //   "KHR": 49.4324,
  //   "KID": 0.01778,
  //   "KMF": 5.4033,
  //   "KWD": 0.003658,
  //   "KYD": 0.009971,
  //   "KZT": 5.6800,
  //   "LAK": 262.6603,
  //   "LBP": 1070.8906,
  //   "LKR": 3.6268,
  //   "LRD": 2.3348,
  //   "LSL": 0.2165,
  //   "LYD": 0.05783,
  //   "MAD": 0.1177,
  //   "MDL": 0.2113,
  //   "MGA": 53.7941,
  //   "MKD": 0.6747,
  //   "MMK": 30.8929,
  //   "MNT": 40.4500,
  //   "MOP": 0.09622,
  //   "MRU": 0.4757,
  //   "MUR": 0.5601,
  //   "MVR": 0.1847,
  //   "MWK": 20.8791,
  //   "MXN": 0.2119,
  //   "MYR": 0.05595,
  //   "MZN": 0.7647,
  //   "NAD": 0.2165,
  //   "NGN": 19.1142,
  //   "NIO": 0.4408,
  //   "NOK": 0.1294,
  //   "NPR": 1.6000,
  //   "NZD": 0.01975,
  //   "OMR": 0.004601,
  //   "PAB": 0.01197,
  //   "PEN": 0.04450,
  //   "PGK": 0.04621,
  //   "PHP": 0.6987,
  //   "PKR": 3.3339,
  //   "PLN": 0.04695,
  //   "PYG": 89.5902,
  //   "QAR": 0.04355,
  //   "RON": 0.05452,
  //   "RSD": 1.2852,
  //   "RWF": 16.1366,
  //   "SBD": 0.1014,
  //   "SCR": 0.1656,
  //   "SDG": 5.3480,
  //   "SEK": 0.1270,
  //   "SGD": 0.01609,
  //   "SHP": 0.009230,
  //   "SLE": 0.2812,
  //   "SLL": 281.2401,
  //   "SOS": 6.8374,
  //   "SRD": 0.3565,
  //   "SSP": 26.3341,
  //   "STN": 0.2691,
  //   "SYP": 153.9170,
  //   "SZL": 0.2165,
  //   "THB": 0.4316,
  //   "TJS": 0.1277,
  //   "TMT": 0.04187,
  //   "TND": 0.03727,
  //   "TOP": 0.02793,
  //   "TRY": 0.3956,
  //   "TTD": 0.08115,
  //   "TVD": 0.01778,
  //   "TWD": 0.3896,
  //   "TZS": 31.9470,
  //   "UAH": 0.4938,
  //   "UGX": 44.1558,
  //   "UYU": 0.4800,
  //   "UZS": 150.8954,
  //   "VES": 0.4368,
  //   "VND": 303.9399,
  //   "VUV": 1.4226,
  //   "WST": 0.03237,
  //   "XAF": 7.2045,
  //   "XCD": 0.03231,
  //   "XDR": 0.009016,
  //   "XOF": 7.2045,
  //   "XPF": 1.3106,
  //   "YER": 2.9937,
  //   "ZAR": 0.2165,
  //   "ZMW": 0.3100,
  //   "ZWL": 0.1646
  // }

  const calculatedPrice = (price) => {
    return (price * exchangeRates[currency]).toFixed(2);
  }

  const currencySymbols = {
    "INR": "₹",  // Indian Rupee
    "EUR": "€",  // Euro
    "USD": "$",  // United States Dollar
    "GBP": "£",  // British Pound Sterling
    "AED": "د.إ",  // United Arab Emirates Dirham
    "AUD": "A$",   // Australian Dollar
    "CAD": "$",    // Canadian Dollar
    "CNY": "¥",    // Chinese Yuan Renminbi
    "JPY": "¥",   // Japanese Yen
    "KRW": "₩",   // South Korean Won
    "SAR": "ر.س", // Saudi Riyal
    "RUB": "₽",   // Russian Ruble

    "AFN": "؋",    // Afghan Afghani
    "ALL": "Lek",  // Albanian Lek
    "AMD": "Դ",    // Armenian Dram
    "ANG": "ANG",  // Netherlands Antillean Guilder
    "AOA": "Kz",   // Angolan Kwanza
    "ARS": "$",    // Argentine Peso
    "AWG": "ƒ",    // Aruban Florin
    "AZN": "₼",    // Azerbaijani Manat
    "BAM": "KM",   // Bosnia-Herzegovina Convertible Mark
    "BBD": "$",    // Barbadian Dollar
    "BDT": "৳",    // Bangladeshi Taka
    "BGN": "лв",   // Bulgarian Lev
    "BHD": ".د.ب", // Bahraini Dinar
    "BIF": "FBu",  // Burundian Franc
    "BMD": "$",    // Bermudian Dollar
    "BND": "$",    // Brunei Dollar
    "BOB": "$b",   // Bolivian Boliviano
    "BRL": "R$",   // Brazilian Real
    "BSD": "$",    // Bahamian Dollar
    "BTN": "Nu.",  // Bhutanese Ngultrum
    "BWP": "P",    // Botswana Pula
    "BYN": "Br",   // Belarusian Ruble
    "BZD": "BZ$",  // Belize Dollar
    "CDF": "CDF",  // Congolese Franc
    "CHF": "₣",    // Swiss Franc
    "CLP": "$",    // Chilean Peso
    "COP": "$",    // Colombian Peso
    "CRC": "₡",    // Costa Rican Colón
    "CUP": "₱",    // Cuban Peso
    "CVE": "CVE",  // Cape Verdean Escudo
    "CZK": "Kč",   // Czech Koruna
    "DJF": "Fdj",  // Djiboutian Franc
    "DKK": "kr.",  // Danish Krone
    "DOP": "RD$",  // Dominican Peso
    "DZD": "دج",   // Algerian Dinar
    "EGP": "£",    // Egyptian Pound
    "ERN": "Nfk.", // Eritrean Nakfa
    "ETB": "ብር", // Ethiopian Birr
    "FJD": "$",   // Fijian Dollar
    "FKP": "£",   // Falkland Islands Pound
    "FOK": "kr",  // Faroese Króna
    "GEL": "₾",   // Georgian Lari
    "GGP": "£",   // Guernsey Pound
    "GHS": "₵",   // Ghanaian Cedi
    "GIP": "£",   // Gibraltar Pound
    "GMD": "D",   // Gambian Dalasi
    "GNF": "FG",  // Guinean Franc
    "GTQ": "Q",   // Guatemalan Quetzal
    "GYD": "$",   // Guyanese Dollar
    "HKD": "$",   // Hong Kong Dollar
    "HNL": "L",   // Honduran Lempira
    "HRK": "kn",  // Croatian Kuna
    "HTG": "G",   // Haitian Gourde
    "HUF": "Ft",  // Hungarian Forint
    "IDR": "Rp",  // Indonesian Rupiah
    "ILS": "₪",   // Israeli New Shekel
    "IMP": "£",   // Isle of Man Pound
    "IQD": "ع.د", // Iraqi Dinar
    "IRR": "﷼",  // Iranian Rial
    "ISK": "kr",  // Icelandic Króna
    "JEP": "£",   // Jersey Pound
    "JMD": "$",   // Jamaican Dollar
    "JOD": "د.ا", // Jordanian Dinar
    "KES": "KSh", // Kenyan Shilling
    "KGS": "сом", // Kyrgyzstani Som
    "KHR": "៛",   // Cambodian Riel
    "KID": "$",   // Kiribati Dollar
    "KMF": "CF",  // Comorian Franc
    "KWD": "د.ك", // Kuwaiti Dinar
    "KYD": "$",   // Cayman Islands Dollar
    "KZT": "〒",   // Kazakhstani Tenge
    "LAK": "₭",   // Lao Kip
    "LBP": "ل.ل", // Lebanese Pound
    "LKR": "₨",   // Sri Lankan Rupee
    "LRD": "$",   // Liberian Dollar
    "LSL": "L",   // Lesotho Loti
    "LYD": "ل.د", // Libyan Dinar
    "MAD": "د.م.", // Moroccan Dirham
    "MDL": "L",   // Moldovan Leu
    "MGA": "Ar",  // Malagasy Ariary
    "MKD": "ден", // Macedonian Denar
    "MMK": "K",   // Burmese Kyat
    "MNT": "₮",   // Mongolian Tögrög
    "MOP": "P",   // Macanese Pataca
    "MRU": "UM",  // Mauritanian Ouguiya
    "MUR": "₨",   // Mauritian Rupee
    "MVR": "ރ.",  // Maldivian Rufiyaa
    "MWK": "MK",  // Malawian Kwacha
    "MXN": "$",   // Mexican Peso
    "MYR": "RM",  // Malaysian Ringgit
    "MZN": "MT",  // Mozambican Metical
    "NAD": "$",   // Namibian Dollar
    "NGN": "₦",   // Nigerian Naira
    "NIO": "C$",  // Nicaraguan Córdoba
    "NOK": "kr",  // Norwegian Krone
    "NPR": "₨",   // Nepalese Rupee
    "NZD": "$",   // New Zealand Dollar
    "OMR": "ر.ع.", // Omani Rial
    "PAB": "B/.", // Panamanian Balboa
    "PEN": "S/.", // Peruvian Sol
    "PGK": "K",   // Papua New Guinean Kina
    "PHP": "₱",   // Philippine Peso
    "PKR": "₨",   // Pakistani Rupee
    "PLN": "zł",  // Polish Złoty
    "PYG": "₲",   // Paraguayan Guaraní
    "QAR": "ر.ق", // Qatari Riyal
    "RON": "lei", // Romanian Leu
    "RSD": "дин.", // Serbian Dinar
    "RWF": "FR",  // Rwandan Franc
    "SBD": "$",   // Solomon Islands Dollar
    "SCR": "₨",   // Seychellois Rupee
    "SDG": "ج.س.", // Sudanese Pound
    "SEK": "kr",  // Swedish Krona
    "SGD": "$",   // Singapore Dollar
    "SHP": "£",   // Saint Helena Pound
    "SLE": "Le",  // Sierra Leonean Leone
    "SLL": "Le",  // Sierra Leonean Leone
    "SOS": "Sh",  // Somali Shilling
    "SRD": "$",   // Surinamese Dollar
    "SSP": "£",   // South Sudanese Pound
    "STN": "Db",  // São Tomé and Príncipe Dobra
    "SYP": "£",   // Syrian Pound
    "SZL": "L",   // Swazi Lilangeni
    "THB": "฿",   // Thai Baht
    "TJS": "ЅМ",  // Tajikistani Somoni
    "TMT": "m",   // Turkmenistani Manat
    "TND": "د.ت", // Tunisian Dinar
    "TOP": "T$",  // Tongan Paʻanga
    "TRY": "₺",   // Turkish Lira
    "TTD": "$",   // Trinidad and Tobago Dollar
    "TVD": "$",   // Tuvaluan Dollar
    "TWD": "NT$", // New Taiwan Dollar
    "TZS": "Sh",  // Tanzanian Shilling
    "UAH": "₴",   // Ukrainian Hryvnia
    "UGX": "USh", // Ugandan Shilling
    "UYU": "$U",  // Uruguayan Peso
    "UZS": "so'm", // Uzbekistani Som
    "VES": "Bs",  // Venezuelan Bolívar
    "VND": "₫",   // Vietnamese Đồng
    "VUV": "VT",  // Vanuatu Vatu
    "WST": "T",   // Samoan Tala
    "XAF": "FCFA", // Central African CFA Franc
    "XCD": "$",   // East Caribbean Dollar
    "XDR": "SDR", // Special Drawing Rights
    "XOF": "CFA", // West African CFA Franc
    "XPF": "₣",   // CFP Franc
    "YER": "﷼",  // Yemeni Rial
    "ZAR": "R",   // South African Rand
    "ZMW": "ZK",  // Zambian Kwacha
    "ZWL": "$"    // Zimbabwean Dollar
  };

  const getCurrencySymbol = () => currencySymbols[currency] || "₹";


  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, calculatedPrice, getCurrencySymbol }}>
      {children}
    </CurrencyContext.Provider>
  );
};